import axios from "axios";
import { AppSettings } from "./constant";
import { msalInstance } from "../msalConfig";


const axiosInstance = axios.create();
let loginData = null;
let logoutTimer = null;

export function setLoginData(data) {
  loginData = data;
}

function decodeJwtExp(token) {
  try {
    const payloadBase64 = token.split(".")[1];
    const payloadJson = atob(payloadBase64.replace(/-/g, "+").replace(/_/g, "/"));
    const payload = JSON.parse(payloadJson);
    return payload.exp; 
  } catch (err) {
    console.error("Failed to decode JWT for expiry:", err);
    return null;
  }
}

function performLogout() {
  const isAD = localStorage.getItem("adLogin") === "true";
  ["token", "adLogin", "username", "accesstoken", "refreshtoken", "userdata", "admin"]
    .forEach((key) => localStorage.removeItem(key));

  if (isAD) {
    msalInstance.logoutRedirect({ postLogoutRedirectUri: window.location.origin });
    return;
  }
  window.location.href = "/";
}

export function scheduleAutoLogout(token) {
  clearAutoLogoutTimer();

  const exp = decodeJwtExp(token);
  if (!exp) return;

  const delayMs = exp * 1000 - Date.now();

  if (delayMs <= 0) {
    performLogout();
    return;
  }

  logoutTimer = setTimeout(() => {
    performLogout();
  }, delayMs);
}

export function clearAutoLogoutTimer() {
  if (logoutTimer) {
    clearTimeout(logoutTimer);
    logoutTimer = null;
  }
}


const existingToken = localStorage.getItem("accesstoken");
if (existingToken) {
  scheduleAutoLogout(existingToken);
}

axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("accesstoken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

let isRefreshing = false;
let refreshSubscribers = [];
let isRedirecting = false;

axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    if (error?.response?.status === 401) {
      if (isRedirecting) return Promise.reject(error);
      isRedirecting = true;
      clearAutoLogoutTimer();
      performLogout();
      return Promise.reject(error);
    }
    if (error?.response?.status === 403) {
      if (!localStorage.getItem("refreshtoken")) {
        clearAutoLogoutTimer();
        localStorage.clear();
        window.location.href = "/";
        return Promise.reject(error);
      }
      if (isRefreshing) {
        try {
          const token = await new Promise((resolve) => {
            refreshSubscribers.push((newToken) => {
              originalRequest.headers.Authorization = `Bearer ${newToken}`;
              resolve(newToken);
            });
          });
          return axiosInstance(originalRequest);
        } catch (error) {
          console.error("Token refresh failed:", error);
          throw error;
        }
      }
      originalRequest._retry = true;
      isRefreshing = true;
      try {
        let refreshtoken = localStorage.getItem("refreshtoken");
        let username = localStorage.getItem("username");
        const response = await axios.post(AppSettings.URLs.login, {
          username: username,
          granttype: "refresh",
          refreshtoken: refreshtoken,
        });
        const newAccessToken = response.data.response.token.accesstoken;
        localStorage.setItem("accesstoken", newAccessToken);
        scheduleAutoLogout(newAccessToken); // re-arm timer for refreshed token
        originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;
        refreshSubscribers.forEach((subscriber) => subscriber(newAccessToken));
        return axiosInstance(originalRequest);
      } catch (error) {
        clearAutoLogoutTimer();
        localStorage.clear();
        window.location.href = "/";
        throw error;
      } finally {
        isRefreshing = false;
        refreshSubscribers = [];
      }
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
 